import { csmWidgetLayout } from '@jira/customer-service__csm-support-widget-layout/src/csmWidgetLayout.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import {
	composeLayouts,
	layoutWithCondition,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingBrandingAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-branding/src/helpCenterSettingBrandingAppEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { csmExperienceBrandingRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceBrandingRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';

const csmExperienceBrandingPageEntryPoint = createPageEntryPoint({
	main,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
	},
});

export const csmExperienceBrandingRouteEntry: Route = createEntry(
	csmExperienceBrandingRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.csm-experience-branding',
		layout: layoutWithCondition(
			() => fg('csm-support-widget-in-csm'),
			composeLayouts(serviceProjectLayout, csmWidgetLayout),
			serviceProjectLayout,
		),
		navigation: {
			sidebarId: SidebarIdCsmApp,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? csmExperienceBrandingPageEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [...getCustomerServiceL1NavigationResources(), ...getCsmExperiencesResources()],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
